import React, { useEffect, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import SparkMD5 from "spark-md5";
// Types
import { ConsentDocumentInfo } from "./IntakeSteps/IntakeFormConsentScreen";

type ConsentToTreatDocProps = {
  setConsentDocumentInfo: (info: ConsentDocumentInfo) => void;
};

export const ConsentToTreatDoc = React.memo(({ setConsentDocumentInfo }: ConsentToTreatDocProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const {
    i18n: { language },
  } = useTranslation();

  const iframeSrc = useMemo(() => {
    const formattedLng = language.replace("-", "_").toUpperCase();
    return `/MCS_CONSENT_${formattedLng}_v2.0.html`;
  }, [language]);

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.style.height = "2800px";
    }
  }, []);

  useEffect(() => {
    const saveDataToLocalStorage = async (): Promise<void> => {
      try {
        const response = await fetch(iframeSrc);
        const arrayBuffer = await response.arrayBuffer();
        const hash = SparkMD5.ArrayBuffer.hash(arrayBuffer);
        const disclosureFileName = iframeSrc.replace(/^\//, "");

        setConsentDocumentInfo({
          disclosureFileName,
          disclosureMd5: hash,
        });
      } catch (error) {
        console.error("Error fetching or hashing consent form:", error);
      }
    };

    saveDataToLocalStorage();
  }, [iframeSrc, setConsentDocumentInfo]);

  return <iframe src={iframeSrc} className="w-full" ref={iframeRef} />;
});

ConsentToTreatDoc.displayName = "ConsentToTreatDoc";
